import { Injectable, Inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ApiRequestService } from './api-request.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { map, catchError, tap } from 'rxjs/operators';
import {Download} from '../../../shared';
import { HttpParams} from '@angular/common/http';

@Injectable()
export class ExtService {
  constructor(
      private apiRequest: ApiRequestService,
      private http: HttpClient
  ) {}

    // addDist(down: Download): Observable<any> {
    //     return this.apiRequest.post('adddist', down);
    // }

    uploadFile(file: File, app: string, platform: string, bundle: string, version: string, title: string): Observable<any> {

        return this.apiRequest.postFile('api/upload', file, app, platform, bundle, version, title);
    }


    addDist(down: Download): Observable<any> {
        return this.apiRequest.post('adddist', down);
    }

    getDistList(): Observable<any> {
        const channels = new Subject<any>();
        this.apiRequest.get('distlist')
            .subscribe(jsonResp => {
                channels.next(jsonResp);
            });
        return channels;
    }

    getDistApp(app: string): Observable<any> {
        let params: HttpParams = new HttpParams();
        params = params.append('app', app);
        const channels = new Subject<any>();
        this.apiRequest.get('distapp',params)
            .subscribe(jsonResp => {
                channels.next(jsonResp);
            });
        return channels;
    }

    getDistinfos(): Observable<any> {
        const channels = new Subject<any>();
        this.apiRequest.get('distinfo')
            .subscribe(jsonResp => {
                channels.next(jsonResp);
            });
        return channels;
    }

  getExts(url: string): Observable<any> {
      let headers = new HttpHeaders({
          'Accept': 'text/xml plist',
          'Content-Type': 'application/octet-stream ipa'
      });
      // return this.http.get('/ext/ab511/test.html', {headers: headers}).pipe(
      //     map(this.extractData));
      //return this.http.get('/ext/ab511/test.html', {responseType: 'text'});
      return this.http.get(url, {responseType: 'text'});
  }
    private extractData(res: Response) {
        let body = res;
        return body || { };
    }

    updateClick(down: Download): Observable<any> {
        return this.apiRequest.post('install/add', down);
    }

}
